import { render, staticRenderFns } from "./upperMasterLowerSlave.vue?vue&type=template&id=4dee2640&scoped=true&"
import script from "./upperMasterLowerSlave.vue?vue&type=script&lang=js&"
export * from "./upperMasterLowerSlave.vue?vue&type=script&lang=js&"
import style0 from "./upperMasterLowerSlave.vue?vue&type=style&index=0&id=4dee2640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dee2640",
  null
  
)

export default component.exports